import React, { useRef } from 'react';
import { MOBILE_NAV_INACTIVE_COLOR } from '../navigationColors';

let discoverMaskUid = 0;

function useDiscoverMaskId() {
  const idRef = useRef(null);
  if (idRef.current === null) {
    discoverMaskUid += 1;
    idRef.current = `discover-nav-mask-${discoverMaskUid}`;
  }
  return idRef.current;
}

/** Discover / cloud nav icon. Defaults to the shared mobile-nav idle color. */
export default function DiscoverNavIconSvg({
  width = 24,
  height = 24,
  color = MOBILE_NAV_INACTIVE_COLOR,
  ...rest
}) {
  const maskId = useDiscoverMaskId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      style={{ color }}
      {...rest}
    >
      <path
        d="M17.365 10.4982V8.01747C17.365 3.90722 14.033 0.575195 9.92272 0.575195C5.81246 0.575195 2.48044 3.90722 2.48044 8.01747L2.48044 10.4982"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
      />
      <path
        d="M14.8843 10.4984L14.8843 8.01768C14.8843 5.2775 12.6629 3.05615 9.92273 3.05615C7.18256 3.05615 4.96121 5.2775 4.96121 8.01768V10.4984"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
      />
      <path
        d="M12.4033 8.8443V8.01738C12.4033 6.6473 11.2926 5.53662 9.92253 5.53662C8.55245 5.53662 7.44177 6.6473 7.44177 8.01738L7.44177 8.8443"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
      />
      <mask id={maskId} fill="white">
        <path d="M9.95801 8.01807C11.7959 8.01821 13.4173 8.92926 14.3828 10.3179C14.9022 10.0466 15.4951 9.89307 16.124 9.89307C18.1788 9.89326 19.8447 11.5343 19.8447 13.5581C19.8445 15.5817 18.1787 17.222 16.124 17.2222C15.3803 17.2222 14.6877 17.0064 14.1064 16.6362C13.1236 17.8191 11.6309 18.5746 9.95801 18.5747C8.27082 18.5747 6.76569 17.8071 5.7832 16.6069C5.19278 16.995 4.48382 17.2222 3.7207 17.2222C1.66591 17.2221 0.000184717 15.5818 0 13.5581C0 11.5343 1.6658 9.89316 3.7207 9.89307C4.36997 9.89307 4.9804 10.0573 5.51172 10.3452C6.47485 8.94066 8.10759 8.01807 9.95801 8.01807Z" fill="white" />
      </mask>
      <path
        d="M9.95801 8.01807L9.9581 6.86807H9.95801V8.01807ZM14.3828 10.3179L13.4386 10.9744L14.017 11.8063L14.9152 11.3372L14.3828 10.3179ZM16.124 9.89307L16.1241 8.74307H16.124V9.89307ZM19.8447 13.5581L20.9947 13.5582V13.5581H19.8447ZM16.124 17.2222V18.3722H16.1241L16.124 17.2222ZM14.1064 16.6362L14.7242 15.6662L13.8695 15.1219L13.2219 15.9013L14.1064 16.6362ZM9.95801 18.5747V19.7247H9.9581L9.95801 18.5747ZM5.7832 16.6069L6.67305 15.8785L6.01698 15.0771L5.15152 15.646L5.7832 16.6069ZM3.7207 17.2222L3.72065 18.3722H3.7207V17.2222ZM0 13.5581H-1.15V13.5582L0 13.5581ZM3.7207 9.89307V8.74307H3.72065L3.7207 9.89307ZM5.51172 10.3452L4.96385 11.3563L5.87444 11.8497L6.46015 10.9956L5.51172 10.3452ZM9.95801 8.01807L9.95792 9.16807C11.408 9.16818 12.6816 9.88557 13.4386 10.9744L14.3828 10.3179L15.327 9.66138C14.1531 7.97294 12.1837 6.86824 9.9581 6.86807L9.95801 8.01807ZM14.3828 10.3179L14.9152 11.3372C15.2734 11.1501 15.6841 11.0431 16.124 11.0431V9.89307V8.74307C15.3062 8.74307 14.531 8.94307 13.8504 9.29852L14.3828 10.3179ZM16.124 9.89307L16.1239 11.0431C17.5601 11.0432 18.6947 12.1858 18.6947 13.5581H19.8447H20.9947C20.9947 10.8829 18.7976 8.74331 16.1241 8.74307L16.124 9.89307ZM19.8447 13.5581L18.6947 13.558C18.6946 14.93 17.5603 16.072 16.1239 16.0722L16.124 17.2222L16.1241 18.3722C18.7971 18.3719 20.9945 16.2335 20.9947 13.5582L19.8447 13.5581ZM16.124 17.2222V16.0722C15.6055 16.0722 15.1264 15.9224 14.7242 15.6662L14.1064 16.6362L13.4887 17.6062C14.2491 18.0905 15.155 18.3722 16.124 18.3722V17.2222ZM14.1064 16.6362L13.2219 15.9013C12.4502 16.8301 11.2777 17.4246 9.95792 17.4247L9.95801 18.5747L9.9581 19.7247C11.9842 19.7246 13.797 18.8081 14.991 17.3712L14.1064 16.6362ZM9.95801 18.5747V17.4247C8.62644 17.4247 7.44406 16.8203 6.67305 15.8785L5.7832 16.6069L4.89335 17.3354C6.08732 18.7939 7.91519 19.7247 9.95801 19.7247V18.5747ZM5.7832 16.6069L5.15152 15.646C4.74289 15.9146 4.25247 16.0722 3.7207 16.0722V17.2222V18.3722C4.71517 18.3722 5.64268 18.0755 6.41489 17.5679L5.7832 16.6069ZM3.7207 17.2222L3.72075 16.0722C2.28437 16.0721 1.15013 14.9301 1.15 13.558L0 13.5581L-1.15 13.5582C-1.14976 16.2335 1.04745 18.372 3.72065 18.3722L3.7207 17.2222ZM0 13.5581H1.15C1.15 12.1857 2.28456 11.0431 3.72075 11.0431L3.7207 9.89307L3.72065 8.74307C1.04704 8.74318 -1.15 10.8829 -1.15 13.5581H0ZM3.7207 9.89307V11.0431C4.17397 11.0431 4.5966 11.1573 4.96385 11.3563L5.51172 10.3452L6.05959 9.33411C5.3642 8.95731 4.56598 8.74307 3.7207 8.74307V9.89307ZM5.51172 10.3452L6.46015 10.9956C7.21483 9.89502 8.49724 9.16807 9.95801 9.16807V8.01807V6.86807C7.71795 6.86807 5.73488 7.9863 4.56328 9.69485L5.51172 10.3452Z"
        fill="currentColor"
        mask={`url(#${maskId})`}
      />
    </svg>
  );
}
